<div role="search" aria-describedby="search">
  <div class="col-md-12 clear-all tooltip-flex-container">
    <label for="addressSearch" id="search"
      [ngClass]="pageName === 'yourPensionSavings' ? 'form-label margin-top-15' : 'form-label' ">
      {{(pageName === 'yourPensionSavings'? 'Pension provider address': 'Address search')}}
    </label>
    @if(pageName === 'registration') {
    <div class="info-icon d-view">
      <app-tool-tip-notification [childId]="'addressToolTipInfoConfig'" [tooltipData]="tooltipData"
        class="col-sm-1 padding-for-toolTip" (displayMobileTooltipEmitter)="displayTooltipMessage()">
      </app-tool-tip-notification>
    </div>
    <div class="col-md-12 clear-all info-icon mt-view">
      <app-tool-tip-notification [childId]="'addressToolTipInfoConfig'" [tooltipData]="tooltipData"
        (displayMobileTooltipEmitter)="displayTooltipMessage()">
      </app-tool-tip-notification>
    </div>
    }

  </div>
  <input class="form-control" style="margin-bottom: 10px;" id="addressSearch" name="addressSearch"
    [placeholder]="contentData['addressSearchplaceholder']" type="text" (keyup)="searchTerm$.next($event.target.value)"
    autocomplete="off">

  @if (suggestiontext) {
  <ul class="autofill" [ngClass]="{hideList:!isListAddressEnabled}">
    @for (txt of suggestiontext; track txt; let i = $index) {
    <li [(value)]="suggestiontext[i]" (click)="onSelectAddress(txt)">
      {{txt}}
    </li>
    }
  </ul>
  }
  @if (displayTooltipAlert) {
  <app-modal [modalConfig]="tooltipModalConfig" (closeModal)="closeTooltipModal()"
    (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
    [tooltipFlag]="true"></app-modal>
  }
  @if ( parent && parent.get('addressline1') && parent.get('addressline1').touched && parent.get('addressline1').errors)
  {
  <div class="form-validation-error clear-both">
    <i class="icon icon-error" aria-hidden="true"></i>
    <p [id]="'address-error'">
      Please enter an address
    </p>
  </div>
  }

</div>